// in src/posts.js
import * as React from 'react'
import {
  Create,
  Edit,
  SimpleForm,
  TextInput,
  DateInput,
  ReferenceManyField,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  required,
  SimpleShowLayout,
  Show,
  RichTextField,
} from 'react-admin'

const CategoryDetail = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source='name' />
      {/* <TextField source='description' /> */}
      <RichTextField source='description' />
      <DateField label='Created At' source='createdAt' />
    </SimpleShowLayout>
  </Show>
)

export default CategoryDetail
